(function () {
  if (window.__clearRecentSearchesLoaded) return;
  window.__clearRecentSearchesLoaded = true;

  var REMOVED_SEARCHES_KEY = 'removed_search_keywords';
  var SEARCH_COUNT_KEY = 'search_keywords_count';
  var predictiveSearchResizeTimer = 0;
  var predictiveSearchMutationTimer = 0;

  /* ── localStorage helpers ── */

  function getRemovedSearches() {
    try { return JSON.parse(localStorage.getItem(REMOVED_SEARCHES_KEY)) || []; }
    catch (e) { return []; }
  }

  function getSearchCounts() {
    try { return JSON.parse(localStorage.getItem(SEARCH_COUNT_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function incrementSearchCount(keyword) {
    var normalized = (keyword || '').trim().toLowerCase();
    if (!normalized) return;
    var counts = getSearchCounts();
    counts[normalized] = (counts[normalized] || 0) + 1;
    localStorage.setItem(SEARCH_COUNT_KEY, JSON.stringify(counts));
  }

  function getPredictiveSearchWidth() {
    var root = document.documentElement;
    var predictiveSearchEls = Array.from(
      document.querySelectorAll('.predictive-search .search-input'),
    );

    if (!predictiveSearchEls.length) {
      root.style.removeProperty('--predictive-search-width');
      return;
    }

    var targetEl =
      predictiveSearchEls.find(function (el) {
        return el instanceof HTMLElement && el.offsetWidth > 0;
      }) || predictiveSearchEls[0];

    if (!(targetEl instanceof HTMLElement)) {
      root.style.removeProperty('--predictive-search-width');
      return;
    }

    var inputWidth = Math.round(targetEl.getBoundingClientRect().width);

    root.style.setProperty('--predictive-search-width', inputWidth + 'px');
  }

  function bindPredictiveSearchWidthVar() {
    getPredictiveSearchWidth();

    window.addEventListener('resize', function () {
      clearTimeout(predictiveSearchResizeTimer);

      predictiveSearchResizeTimer = setTimeout(function () {
        getPredictiveSearchWidth();
      }, 120);
    });
  }

  /* ── Clear all recent searches ── */

  function clearAllRecentSearches() {
    var allKeywords = [];

    document.querySelectorAll('.suggestion-queries-container').forEach(function (container) {
      var items = container.querySelectorAll('.boost-sd__suggestion-queries-item--recent');

      items.forEach(function (item) {
        var title = (item.getAttribute('data-title') || '').trim().toLowerCase();
        if (title && allKeywords.indexOf(title) === -1) allKeywords.push(title);
      });

      // Only hide the list, keep header + clear button
      var list = container.querySelector('.boost-sd__suggestion-queries-list');
      if (list) list.style.display = 'none';
    });

    // Save removed keywords
    var existing = getRemovedSearches();
    var merged = existing.concat(allKeywords).filter(function (v, i, a) {
      return a.indexOf(v) === i;
    });
    localStorage.setItem(REMOVED_SEARCHES_KEY, JSON.stringify(merged));

    // Reset counts for cleared keywords so new searches start fresh
    var counts = getSearchCounts();
    allKeywords.forEach(function (kw) {
      delete counts[kw];
    });
    localStorage.setItem(SEARCH_COUNT_KEY, JSON.stringify(counts));
  }

  /* ── Filter removed keywords ── */

  function filterRemovedRecentSearches() {
    var removed = getRemovedSearches();
    if (!removed.length) return;

    document.querySelectorAll('.suggestion-queries-container').forEach(function (container) {
      var items = container.querySelectorAll('.boost-sd__suggestion-queries-item--recent');
      var visibleCount = 0;

      items.forEach(function (item) {
        var title = (item.getAttribute('data-title') || '').trim().toLowerCase();
        if (removed.indexOf(title) !== -1) {
          item.style.display = 'none';
        } else {
          visibleCount++;
        }
      });

      if (visibleCount === 0) {
        var list = container.querySelector('.boost-sd__suggestion-queries-list');
        if (list) list.style.display = 'none';
      }
    });
  }

  /* ── Inject Clear button ── */

  function injectClearButton() {
    var headers = document.querySelectorAll('.boost-sd__suggestion-queries-header--recent');

    headers.forEach(function (header) {
      if (header.closest('.boost-sd__suggestion-queries-header-wrapper')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'boost-sd__suggestion-queries-header-wrapper';

      header.parentElement.insertBefore(wrapper, header);
      wrapper.appendChild(header);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'boost-sd__clear-recent-searches';
      btn.setAttribute('aria-label', 'Clear recent searches');
      btn.innerHTML =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<mask id="mask0_clear_btn" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">' +
        '<rect width="24" height="24" fill="#D9D9D9"/>' +
        '</mask>' +
        '<g mask="url(#mask0_clear_btn)">' +
        '<path d="M6.40013 18.3076L5.69238 17.5999L11.2924 11.9999L5.69238 6.39989L6.40013 5.69214L12.0001 11.2921L17.6001 5.69214L18.3079 6.39989L12.7079 11.9999L18.3079 17.5999L17.6001 18.3076L12.0001 12.7076L6.40013 18.3076Z" fill="currentColor"/>' +
        '</g>' +
        '</svg>' +
        '<span>Clear</span>';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearAllRecentSearches();
      });

      wrapper.appendChild(btn);
    });
  }

  /* ── Track search submissions ── */

  var lastTrackedSearch = '';
  var lastTrackedTime = 0;

  function restoreFromRemoved(normalized) {
    var removed = getRemovedSearches();
    var idx = removed.indexOf(normalized);
    if (idx !== -1) {
      removed.splice(idx, 1);
      localStorage.setItem(REMOVED_SEARCHES_KEY, JSON.stringify(removed));
    }
  }

  function trackOnce(query) {
    var normalized = query.trim().toLowerCase();
    var now = Date.now();
    if (!normalized || (normalized === lastTrackedSearch && now - lastTrackedTime < 2000)) return;
    lastTrackedSearch = normalized;
    lastTrackedTime = now;
    incrementSearchCount(query);
    restoreFromRemoved(normalized);
  }

  function trackSearchSubmissions() {
    // Use capture phase to catch events before Boost SDK can intercept
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;

      var boostInput = e.target.closest('.boost-sd__search-widget-init-input');
      var themeInput = e.target.closest('input[name="q"]');
      var input = boostInput || themeInput;

      if (!input) return;

      var query = input.value.trim();
      if (query) trackOnce(query);
    }, true);

    // Track form submissions
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('.predictive-search-form, form[action*="search"]')) return;

      var input = form.querySelector('input[name="q"], .boost-sd__search-widget-init-input');
      if (!input) return;

      var query = input.value.trim();
      if (query) trackOnce(query);
    }, true);

    // Track clicks on recent search links (also count)
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.boost-sd__suggestion-queries-item--recent a');
      if (!link) return;

      var item = link.closest('.boost-sd__suggestion-queries-item--recent');
      if (!item) return;

      var title = (item.getAttribute('data-title') || '').trim();
      if (title) trackOnce(title);
    }, true);
  }

  /* ── Main process ── */

  function processRecentSearches() {
    injectClearButton();
    filterRemovedRecentSearches();
  }

  // MutationObserver to re-inject after Boost SDK re-renders
  var observer = new MutationObserver(function () {
    clearTimeout(predictiveSearchMutationTimer);
    predictiveSearchMutationTimer = setTimeout(function () {
      getPredictiveSearchWidth();
    }, 120);

    var header = document.querySelector('.boost-sd__suggestion-queries-header--recent');
    if (header && !header.closest('.boost-sd__suggestion-queries-header-wrapper')) {
      processRecentSearches();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  bindPredictiveSearchWidthVar();
  trackSearchSubmissions();
})();
